import { render, staticRenderFns } from "./ModalInputKasVirtual.vue?vue&type=template&id=6afa6960&"
import script from "./ModalInputKasVirtual.vue?vue&type=script&lang=js&"
export * from "./ModalInputKasVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports